module.exports = __webpack_public_path__ + "static/img/pc-web-main-01@t.a97d484.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/pc-web-main-01@t.jpg
// module id = j60n
// module chunks = 0